import { Route, Routes } from '@angular/router';
import { checklisteRoutes } from '@softapps/allgemein/checkliste';
import { dashboardRoutes } from '@softapps/allgemein/dashboard';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { passwordRoutes } from '@softapps/allgemein/password';
import { sendNotificationRoutes } from '@softapps/allgemein/send-notification';
import { notificationRoutes, settingsRoutes } from '@softapps/allgemein/utils';
import { bauprofiRoutes } from '@softapps/dfh/bauprofi';
import { bonusabfrageRoutes } from '@softapps/dfh/bonusabfrage';
//import { kinoabfrageRoutes } from '@softapps/diesel/kinoabfrage';
import { wiegungRoutes } from '@softapps/feichtinger/wiegung';
import { freigabeRoutes } from '@softapps/fibu/freigabe';
import { haftruecklassRoutes } from '@softapps/fibu/haftruecklass';
import { offenePostenRoutes } from '@softapps/fibu/offene-posten';
import { arbeitsberichtRoutes } from '@softapps/gewerbe/arbeitsbericht';
import { workNoteRoutes } from '@softapps/gewerbe/arbeitsschein';
import { dokumentationRoutes } from '@softapps/gewerbe/dokumentation';
import { artikelinfoRoutes as artikelinfoRoutesHandel } from '@softapps/handel/artikelinfo';
import { inventurRoutes } from '@softapps/lager/inventur';
import { kommissionierungRoutes } from '@softapps/lager/kommissionierung';
import { lagerkorrekturRoutes } from '@softapps/lager/lagerkorrektur';
import { lagerkorrekturArtikelRoutes } from '@softapps/lager/lagerkorrektur-artikel';
import { lagerplatzUmlagerungRoutes } from '@softapps/lager/lagerplatz-umlagerung';
import { lagerstandRoutes } from '@softapps/lager/lagerstand';
import { palettenUmlagerungRoutes } from '@softapps/lager/paletten-umlagerung';
import { lieferantenstammRoutes } from '@softapps/lieferantenstamm';
import { kommissionierungRoutes as llrKommissionierungRoutes } from '@softapps/llr/kommisionierung';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { einseitigeLagerbuchungRoutes } from '@softapps/mde/einseitige-lagerbuchung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { arbeitsberichtStatistikRoutes } from '@softapps/pms/arbeitsbericht-statistik';
import { pmsMeldungRoutes } from '@softapps/pms/pmsmeldung';
import { statusabfrageRoutes } from '@softapps/pms/statusabfrage';
import { pmsStempelTerminalRoutes } from '@softapps/pms/stempel-terminal';
import { stempelerfassungRoutes } from '@softapps/pms/stempelerfassung';
import { absatzplanRoutes } from '@softapps/produktion/absatzplan';
import { kundenKonditionslisteRoutes } from '@softapps/produktion/kunden-konditionsliste';
import { produktionsauftragRoutes } from '@softapps/produktion/produktionsauftrag';
import { pruefprotokollRoutes } from '@softapps/produktion/pruefprotokoll';
import { rohstoffbereitstellungRoutes } from '@softapps/produktion/rohstoffbereitstellung';
import { rohstoffbilanzRoutes } from '@softapps/produktion/rohstoffbilanz';
import { produktkalkulationRoutes } from '@softapps/schmuck/produktkalkulation';
import { hardwareRoutes } from '@softapps/softline/hardware';
import {
  portalRegistrationAdminRoutes,
  portalRegistrationRoutes,
} from '@softapps/softline/portal-registration';
import { rdpLogRoutes } from '@softapps/softline/rdp-log';
import { ticketRoutes } from '@softapps/softline/ticket';
import { gewichtsportalRoutes } from '@softapps/titz/gewichtsportal';
import { archivbelegUploadRoutes } from '@softapps/wws/archivbeleg-upload';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { basisartikelstandRoutes } from '@softapps/wws/basisartikelstand';
import { energietransportRoutes } from '@softapps/wws/energietransport';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { kreditlimitRoutes } from '@softapps/wws/kreditlimit';
import { kundenabfrageRoutes } from '@softapps/wws/kundenabfrage';
import { kundenanlageRoutes } from '@softapps/wws/kundenanlage';
import { lieferscheinRoutes } from '@softapps/wws/lieferschein';
import { objektabfrageRoutes } from '@softapps/wws/objektabfrage';
import { posRoutes } from '@softapps/wws/pos';
import { posDisplayRoutes } from '@softapps/wws/pos-display';
import { subkundenRoutes } from '@softapps/wws/subkunden';
import { umsatzstatistikRoutes } from '@softapps/wws/umsatzstatistik';
import { updatedArticleLabelPrintRoutes } from '@softapps/wws/updated-article-label-print';
import { warenuebernahmeRoutes } from '@softapps/wws/warenuebernahme';
import { CustomerConfig } from '../customer-config.type';
import { authenticationMode } from './authentication-mode';

export const publicRoutes: Route[] = [
  // '/login' MUST follow the auth mode. JWT contributes the real login page via
  // withLogin() → provideSoftAppsRoutes({ public: loginRoutes }), so listing
  // loginRoutes here too would register the path twice. The BFF has no login page
  // of its own — sending '/login' to the shell starts its server-side flow.
  // Getting this wrong redirect-loops the JwtAuthenticationGuard.
  ...(authenticationMode === 'bff'
    ? [{ path: 'login', redirectTo: '/auth' } as Route]
    : []),
  ...passwordRoutes,
  ...portalRegistrationRoutes,
  ...settingsRoutes,
];

export const terminalRoutes: Route[] = [
  ...pmsStempelTerminalRoutes,
  ...posRoutes,
  ...posDisplayRoutes,
];

export function routeFactory(appConfig: CustomerConfig): Routes {
  return [
    ...checklisteRoutes,
    ...dashboardRoutes,
    ...moduleRoutes,
    ...settingsRoutes,
    ...notificationRoutes,
    ...dashboardRoutes,
    ...sendNotificationRoutes,
    //...utilitiesRoutes,
    //...eslLinkRoutes,

    ...freigabeRoutes,
    ...haftruecklassRoutes,
    ...offenePostenRoutes,

    ...arbeitsberichtRoutes,
    ...workNoteRoutes(appConfig.moduleConfig?.workNote),
    ...dokumentationRoutes,
    ...pmsStempelTerminalRoutes,

    ...artikelinfoRoutesHandel,

    ...inventurRoutes,
    ...kommissionierungRoutes,
    ...llrKommissionierungRoutes,
    ...lagerkorrekturRoutes,
    ...lagerkorrekturArtikelRoutes,
    ...lagerplatzUmlagerungRoutes,
    ...lagerstandRoutes,
    ...palettenUmlagerungRoutes,

    ...warenuebernahmeRoutes,
    ...artikelvorratRoutes,
    ...bestellvorschlagRoutes,
    ...bestellerfassungRoutes,
    ...einseitigeLagerbuchungRoutes,
    ...etikettendruckRoutes,
    ...materiallieferscheinScanRoutes,
    ...retourenRoutes,
    ...warenverprobungRoutes,

    ...arbeitsberichtStatistikRoutes,
    ...statusabfrageRoutes,
    ...pmsStempelTerminalRoutes,
    ...pmsMeldungRoutes,
    ...stempelerfassungRoutes,

    ...absatzplanRoutes,
    ...kundenKonditionslisteRoutes,
    ...produktionsauftragRoutes,
    ...pruefprotokollRoutes,
    ...rohstoffbereitstellungRoutes,
    ...rohstoffbilanzRoutes,
    //...rueckverfolgungRoutes,

    ...produktkalkulationRoutes,

    //...auftragRoutes,

    ...energietransportRoutes,

    ...archivbelegUploadRoutes,
    ...artikelInfoRoutes,
    ...basisartikelstandRoutes,
    ...gesamtabfrageRoutes,
    ...kreditlimitRoutes,
    ...kundenabfrageRoutes,
    ...kundenanlageRoutes,
    ...lieferantenstammRoutes,
    ...lieferscheinRoutes,
    ...objektabfrageRoutes,
    ...subkundenRoutes,
    ...umsatzstatistikRoutes,
    ...updatedArticleLabelPrintRoutes,

    ...bauprofiRoutes,
    ...bonusabfrageRoutes,

    //...kinoabfrageRoutes,

    ...wiegungRoutes,

    ...gewichtsportalRoutes,

    ...hardwareRoutes,
    ...portalRegistrationAdminRoutes,
    ...rdpLogRoutes,
    ...ticketRoutes,
  ];
}
